var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button-options',{attrs:{"access":_vm.access,"hideAdd":true,"hideDelete":false,"hideEdit":false,"hideDetail":false,"hideDuplicate":false,"viewTo":_vm.viewTo},on:{"onDeleteClicked":_vm.onDeleteClicked,"onEditClicked":_vm.onEditClicked,"onDuplicateClicked":_vm.onDuplicateClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }